
import { defineComponent, ref, computed, watch } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "ProfessionalSummary",
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    formDataTemp: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const businessName = ref<string>("");
    const summary = ref<string>("");
    const defensibleUsp = ref<string>("");
    const overview = ref<string>("");
    const limitLength = 200;
    const store = useStore();
    const formData = ref<Record<string, unknown>>(props.formDataTemp);
    watch(() => props.formDataTemp, (value) => {
      formData.value = { ...value };
      businessName.value = (() => {
        if (businessName.value) {
          formData.value["name"] = businessName.value;
          return businessName.value;
        }
        return value?.name ?? "";
      })();
      summary.value = (() => {
        if (summary.value) {
          formData.value["summary"] = summary.value
          return summary.value
        }
        return value?.summary ?? "";
      })();
      overview.value = (() => {
        if (overview.value) {
          formData.value["overview"] = overview.value;
          return overview.value;
        }
        return value?.overview ?? "";
      })();
      defensibleUsp.value = (() => {
        if (defensibleUsp.value) {
          formData.value["defensibleUsp"] = defensibleUsp.value
          return defensibleUsp.value
        }
        return value?.defensibleUsp ?? "";
      })();
    });
    const limitInput = (e) => {
      if (e.target.value.length >= limitLength) e.preventDefault();
    };
    const fieldChanged = async (event) => {
      formData.value[event.target.name] = event.target.value;
      emit("form-data", formData.value);
    };
    const createDraft = async () => {
      // try {
      //   const res = await store.dispatch(Actions.CREATE_BUSINESS_DRAFT, {
      //     business: JSON.stringify(formData.value),
      //   });
      //   if (res !== true) throw new Error("error in API");
      // } catch (err) {
      //   console.log({ err });
      // }
    };
    return {
      createDraft,
      formData,
      fieldChanged,
      limitInput,
      limitLength,
      summary,
      defensibleUsp,
      overview,
      businessName,
    };
  },
});
